import { FC, SVGProps } from 'react';

import { nullNoop } from 'utils/noop';

export const PointsIcon: FC<SVGProps<SVGSVGElement>> = nullNoop;
